// extracted by mini-css-extract-plugin
export default {"colorBannerText":"#1a1a1a","spinner":"style_spinner__rJrv3","fullScreen":"style_fullScreen__IF84e"};